export const browserHasEnabledWebSocket = !!window.WebSocket
